import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class DestinationFieldLookup extends ModelBase {
    public destinationFieldId: number = 0;

    public destinationFieldName: string = "";

    public destinationTableId: number = 0;

    public destinationTableName: string = "";
}